document.addEventListener('DOMContentLoaded',()=>{
  if( document.querySelectorAll('.RelatedProduct_Images').length > 0 ){
    document.querySelectorAll('.RelatedProducts_Loop a').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        let productBannerLink = target.currentTarget.getAttribute('href');
          gtag('event', 'product_pages_banner_click',{'banner_id': 'complete_the_outfit','banner_url': productBannerLink});      
          dataLayer.push({'event': 'product_pages_banner_click','banner_id': 'complete_the_outfit','banner_url': productBannerLink});      
      })
    })
  }
  if( document.querySelectorAll('.mgelmWp').length > 0 ){
    document.querySelectorAll('.mgelmWp a').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        let listingBannerLink = target.currentTarget.getAttribute('href');
          gtag('event', 'listing_pages_banner_click',{'banner_id': 'listing_page','banner_url': listingBannerLink});  
          dataLayer.push({'event': 'listing_pages_banner_click','banner_id': 'listing_page','banner_url': listingBannerLink});      
      })
    })
  }
  if( document.querySelectorAll('[data-section-type="featured-collection"] .grid-product__image').length > 0 ){
    document.querySelectorAll('[data-section-type="featured-collection"] .grid-product__image a').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        let featuredBannerLink = target.currentTarget.getAttribute('href');
          gtag('event', 'featured_collection_click',{'banner_id': 'featured_collection','banner_url': featuredBannerLink});      
          dataLayer.push({'event': 'featured_collection_click','banner_id': 'featured_collection','banner_url': featuredBannerLink});      
      })
    })    
  }
})